// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2GGYX","footer":"Form_footer__19wW-"};